<template>
  <div class="wid100">


  <div class="about-us">

    <div class="about-us_box" >
      <div class="left-section">
        <img src="https://cyvideo.i-oranges.com/home/3.png" alt="" class="about-usImg">
        <p>
          <router-link to="/about" target="_blank">
            <img src="https://cyvideo.i-oranges.com/home/5.png" class="wid100">
          </router-link>
        </p>
      </div>
      <div class="right-section">
        <div class="awards-info">
            <img src="https://cyvideo.i-oranges.com/home/4.png" alt="">
        </div>
      </div>
    </div>
  </div>
    <div class="wid100">
      <img src="https://cyvideo.i-oranges.com/home/16.jpg" class="wid100" style="vertical-align: middle" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutUs',
};
</script>

<style scoped>
.about-us {
  display: flex;
  justify-content: space-between;
  background-color: #141414;
  color: #fff;

}
.about-us_box{display: flex; width: 76%; margin: 0 auto; padding: 130px 0;}

.left-section {
  width: 41.5%;
}

.left-section .about-usImg {
width:54%;
}

.left-section h3 {
  font-size: 20px;
  color: #ff6600;
  margin-bottom: 20px;
}

.left-section p {
  color: #808080;
  width: 30%;
  margin-top:28px;
}

.left-section .more {
 display: inline-block;
  width:100%;
}
.left-section .more img {
 width:100%;
}

.right-section {
  width: 58%;
}

.awards-info {
  width: 100%;
}
.awards-info img {
  width: 100%;
}


.certificates .imgNode img {
  width: 160px;
  margin-left: 5px;
}


.trophies img {
  width:160px;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/AboutComponent.vue